<template>
    <div>
      <div class="pcnav">
        <div class="navbar_wrap">
          <div class="navbar_menu">
            <el-image style="width: 200px;" :src="require('../../assets/image/logo.png')"
                fit="contain"></el-image>
            <div class="flex">
              <ul class="navbar_ul">
                <li v-for="(item, index) in navbarList" :key="index"
                  :class="activeName==item.name?'navbar_active':''" @click="handleClick(item)">{{item.text}}</li>
              </ul>
              <span class="iconfont icon-shezhi navbar_seticon" @click="gotoSetweb"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="navbar1_wrap flexbet">
        <ul class="navbar_ul">
          <li v-for="(item, index) in navbarphoneList" :key="index"
            :class="activeName==item.name?'navbar_active':''" @click="handleClick(item)">{{item.text}}</li>
        </ul>
        <div class="navbar_more" @click="changeSmall">
          <span class="iconfont icon-gengduo"></span>
        </div>
      </div>
      <div class="navbar_seat"></div>
	  <div class="navbar1_select" v-if="showsmallSelect">
		  <div class="navbar1_selectmenu">
			  <div class="icon_close">
				  <span class="el-icon-close" @click="showsmallSelect = false"></span>
			  </div>
			  <div class="flex flexcolumn">
				  <div class="navtext" @click="gotoPage('home')">首页</div>
				  <div class="navtext" @click="gotoPage('product')">产品展示</div>
				  <div class="navtext" @click="gotoPage('about')">关于我们</div>
				  <div class="navtext" @click="gotoPage('culture')">企业文化</div>
				  <div class="navtext" @click="gotoPage('joinus')">加入我们</div>
			  </div>
		  </div>
	  </div>
    </div>
</template>

<script>
  export default {
      data() {
        return {
          activeNameTwo: 'home',
          windowWidth: 1200,
          showsmallSelect: false,
          navbarList: [{text: '首页', name: 'home'},
            {text: '产品展示', name: 'product'},
            {text: '关于我们', name: 'about'},
            {text: '企业文化', name: 'culture'},
            {text: '加入我们', name: 'joinus'}
          ],
          navbarphoneList: [{text: '首页', name: 'home'},
            {text: '产品展示', name: 'product'},
            {text: '关于我们', name: 'about'},
            {text: '企业文化', name: 'culture'}
          ],
        };
      },
      props: {
        activeName: {
          type: String,
          default: ''
        }
      },
      created() {
        this.activeNameTwo = this.activeName;
        if(this.activeNameTwo=='joinus'){
          this.navbarphoneList = [
            {text: '关于我们', name: 'about'},
            {text: '企业文化', name: 'culture'},
            {text: '加入我们', name: 'joinus'}
          ]
        }
      },
      mounted(){
        this.windowWidth = document.documentElement.clientWidth;
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
                //浏览器变化执行动作
          this.windowWidth = window.innerWidth;
        });
      },
      methods: {
        gotoSetweb(){
          window.open('https://girdeargroup.com/admin', "_blank");
        },
		  changeSmall(){
			  this.showsmallSelect = true;
		  },
		  gotoPage(val){
			  let that = this;
			  that.showsmallSelect = false;
        document.documentElement.scrollTop = 0;
			  if(val=='home'){
			  	that.$router.push({path: `/`});
			  }else{
			  	that.$router.push({path: `/${val}`});
			  }
		  },
        handleClick(item) {
          let that = this;
          document.documentElement.scrollTop = 0
          let val = item.name;
          if(val=='home'){
            that.$router.push({path: `/`});
          }else{
            that.$router.push({path: `/${val}`});
          }
        }
      }
    };
</script>

<style scoped lang="less">
	@media screen and (max-width: 480px){
    .navbar_seat{
      width: 100%;
      height: 50px;
    }
    .pcnav{display: none;}
		.icon-gengduo{font-size: 14px;}
		.navbar1_wrap{
		  padding: 0 15px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 101;
      background-color: #fff;
		  ::v-deep .el-tabs__header{margin-bottom: 0px;}
		  ::v-deep .el-tabs__item{font-size: 16px;padding: 0 16px;}
		}
		.navbar1_select{
			width: 100%;
			height: 100%;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			z-index: 111;
			background-color: #fff;
			.navbar1_selectmenu{
				position: relative;
				padding: 30px;
				.icon_close{
					font-size: 30px;
					display: flex;
					justify-content: flex-end;
				}
				.navtext{
					padding: 10px 20px;
					margin-top: 30px;
					font-size: 16px;
				}
			}
		}
    .navbar_ul{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      padding: 12px 0 12px;
      li{
        border-bottom: 2px solid #fff;
        font-size: 16px;
        color: #989898;
        cursor: pointer;
      }
      .navbar_active{border-color: #D9BF81;color: #D9BF81;}
    }
    .navbar_more{padding-left: 26px;}
	}
	@media screen and (min-width: 481px){
	  .navbar1_wrap{display: none;}
    .navbar_seat{
      width: 100%;
      height: 100px;
    }
    ::v-deep .el-tabs__item{padding: 0 40px;}
    .navbar_ul{
      display: flex;
      align-items: center;
      li{
        margin-right: 80px;
        border-bottom: 2px solid #fff;
        font-size: 20px;
        color: #989898;
        padding-bottom: 4px;
        cursor: pointer;
      }
      .navbar_active{border-color: #D9BF81;color: #D9BF81;}
    }
	}



  ::v-deep .el-tabs__active-bar{background-color: #D9BF81;}
  ::v-deep .el-tabs__item.is-active{color: #D9BF81;font-weight: bold;}
  ::v-deep .el-tabs__item:hover{color: #D9BF81;}
  ::v-deep .el-tabs__item{color: #989898;font-weight: normal;}
  ::v-deep .el-tabs__nav-wrap::after{background-color: #fff;}

  .navbar_wrap{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 99;
    padding: 0 25px;
    height: 100px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    .navbar_menu{
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
	  .navbar_seticon{
      cursor: pointer;
		  margin-top: 5px;font-size: 18px;color: #989898;
	  }
    }
    ::v-deep .el-tabs__item{font-size: 20px;}
  }

</style>
